<div
  class="app-header bg-white"
  [class.showing-side-bar]="showSideBar"
  [class.showing-shelf]="showingShelf && !largeShelf"
  [class.showing-large-shelf]="showingShelf && largeShelf"
>
  <div class="app-header__content">
    <div class="app-header-left w-100">
      <div class="app-header__mobile-menu" [ngClass]="showSideBar? 'mobile-menu-expand' : 'mobile-menu'" (click)="onShowSideBar()">
        <i class="menu-ic-expand">
          <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="26" height="23" fill="#ECECEC"/>
            <path d="M19 11.5L9.25 17.1292L9.25 5.87084L19 11.5Z" fill="#2E3D4F"/>
          </svg>
        </i>
      </div>

      <div *ngIf="!((shouldGroupSearchResults$ | async) || businessLocations > 1)" class="app-header-title">
        <div>
          {{currentViewTitle$ | async}}

          <span class="status-indicator text-nowrap"
            *ngIf="currentViewStatusIndicator$ | async as status"
            [ngClass]="'status-' + status"
          >
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="5.5" cy="5.5" r="5.5" fill="#1CBC8C"/>
            </svg>

            {{ status }}
          </span>
        </div>

        <span class="subtitle">
          {{ currentViewSubtitle$ | async }}
        </span>
      </div>

      <ng-container *ngIf="(shouldGroupSearchResults$ | async) || businessLocations > 1">
        <div class="w-100" style="max-width: 444px">
          <p-autoComplete
            #autocomplete
            field="locationName"
            placeholder="Search location"
            [(ngModel)]="selectedMetadata"
            [completeOnFocus]="true"
            [disabled]="businessLocationsAutocomplete == null"
            [forceSelection]="true"
            [group]="(shouldGroupSearchResults$ | async) || (filteredGroups && filteredGroups.length == 1 && filteredGroups[0].items.length == 0)"
            [suggestions]="filteredGroups"
            (completeMethod)="filterGroupedCity($event, autocomplete)"
            (onBlur)="repopulateSearchSelection$$.next(true)"
            (onFocus)="$event.target.select()"
            (onKeyUp)="focusOnBackspaceClear($event, autocomplete)"
            (onSelect)="repopulateSearchSelection$$.next(false); onSelectLocation($event, autocomplete)"
          >
            <ng-template let-group pTemplate="group">
              <div
                class="d-flex align-items-center"
                [class.justify-content-between]="!group.items.length"
                style="cursor: pointer"
                (click)="onSelectBusiness($event, autocomplete, group)"
              >
                <span>{{ group.label }}</span>
                <small *ngIf="!group.items.length">(no results)</small>
              </div>
            </ng-template>

            <ng-template let-item pTemplate="item">
              <div class="d-flex align-items-center">
                <span>{{ item.locationName }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </ng-container>
    </div>

    <div class="app-header-right">
      <div
        *ngIf="(loggedUser.role.name==='BUSINESS_ADMIN' || loggedUser.role.name==='BUSINESS_USER') && selectedBusinessProfile.trialMode"
        class="trial-indicator">
          Trial ends {{ daysTrial()}}
      </div>

      <app-dots></app-dots>

      <app-user-box (onLogout)="gotoAuth()" (onChangeUser)="changeUser($event)"></app-user-box>
    </div>
  </div>
</div>

<div #sidebar class="app-sidebar sidebar-shadow box-shadow" [ngClass]="showSideBar? 'sidebar-expand' : 'sidebar'">
  <div>
    <div style="height: 100px; text-align: center; padding-top: 13px;">
      <img *ngIf="initialSelectedReseller.logo" class="logo-reseller" [src]="initialSelectedReseller.logo">
      <div *ngIf="!initialSelectedReseller.logo" class="title-reseller">{{initialSelectedReseller.name}}</div>
    </div>
  </div>

  <div
    class="position-relative h-100"
    style="overflow-y: auto; overflow-x: hidden"
    [class.sidebar-content-blur]="!(selectedBusiness$ | async)?.id"
    [ngbTooltip]="!(selectedBusiness$ | async)?.id ? 'You must select a business to continue.' : ''"
  >
    <perfect-scrollbar *ngIf="(selectedBusiness$ | async)?.id">
      <div
        *ngxPermissionsOnly="['viewLocationMenu']"
        #accordion="ngbAccordion"
        ngbAccordion
        class="sidebar-menu"
        [destroyOnHide]="false"
      >
        <div class="menu-item"
          id="nav-business-dashboard"
          (click)="navigateTo('/admin-business/dashboard')"
          [class.menu-item-selected]="router.isActive('/admin-business/dashboard', true)">
          <i class="icons">
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 8.27778H6.22222V0.5H0V8.27778ZM1.55556 2.05556H4.66667V6.72222H1.55556V2.05556ZM7.77778 14.5H14V6.72222H7.77778V14.5ZM9.33333 8.27778H12.4444V12.9444H9.33333V8.27778ZM7.77778 0.5V5.16667H14V0.5H7.77778ZM12.4444 3.61111H9.33333V2.05556H12.4444V3.61111ZM0 14.5H6.22222V9.83333H0V14.5ZM1.55556 11.3889H4.66667V12.9444H1.55556V11.3889Z" fill="#2E3D4F"/>
            </svg>
          </i>
          <div class="menu-item-name">Dashboard</div>
        </div>

        <!-- Reports -->
        <div
          ngbAccordionItem="reports"
          [disabled]="isAccordionActive('reports')"
          [collapsed]="!isAccordionActive('reports')"
        >
          <div ngbAccordionHeader>
            <div ngbAccordionToggle class="menu-item menu-item-expandable"
              id="nav-business-reports"
              (click)="closeInactiveOthers('reports')"
              [class.menu-item-selected]="isAccordionActive('reports')"
            >
              <i class="icons">
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.4444 0.5H1.55556C0.7 0.5 0 1.2 0 2.05556V12.9444C0 13.8 0.7 14.5 1.55556 14.5H12.4444C13.3 14.5 14 13.8 14 12.9444V2.05556C14 1.2 13.3 0.5 12.4444 0.5ZM12.4444 12.9444H1.55556V2.05556H12.4444V12.9444Z" fill="#2E3D4F"/>
                  <path d="M4.66664 7.5H3.11108V11.3889H4.66664V7.5Z" fill="#2E3D4F"/>
                  <path d="M10.8888 3.61111H9.33325V11.3889H10.8888V3.61111Z" fill="#2E3D4F"/>
                  <path d="M7.77772 9.05554H6.22217V11.3889H7.77772V9.05554Z" fill="#2E3D4F"/>
                  <path d="M7.77772 5.94446H6.22217V7.50001H7.77772V5.94446Z" fill="#2E3D4F"/>
                </svg>
              </i>
              <div class="menu-item-name">Reports</div>
            </div>
          </div>

          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="submenu">
                  <div
                    class="submenu-item"
                    (click)="navigateTo('/admin-business/reports', { section: 'analytics' })"
                    [class.submenu-item-selected]="router.isActive('/admin-business/reports?section=analytics', true)">
                    Analytics
                  </div>

                  <div
                    class="submenu-item"
                    (click)="navigateTo('/admin-business/reports', { section: 'settings' })"
                    [class.submenu-item-selected]="router.isActive('/admin-business/reports?section=settings', true)"
                  >
                    Reports Settings
                  </div>

                  <div
                    class="submenu-item"
                    (click)="navigateTo('/admin-business/reports', { section: 'reports' })"
                    [class.submenu-item-selected]="router.isActive('/admin-business/reports?section=reports', true)"
                  >
                    My Reports
                  </div>
                  <div
                    class="submenu-item"
                    (click)="navigateTo('/admin-location/review-analysis')"
                    [class.submenu-item-selected]="router.isActive('/admin-location/review-analysis', true)">
                    Review Insights
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="menu-item"
          id="nav-location-contacts"
          (click)="(!selectedLocation && navigateTo('/admin-business/locations', { next: 'contacts' })) || navigateTo('/admin-location/contacts')"
          [class.menu-item-selected]="router.isActive('/admin-location/contacts', true)"
        >
          <i class="icons">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.05734 2.47799C5.82111 1.88743 5.24914 1.50018 4.61308 1.50018H2.47365C1.65977 1.50018 1 2.1598 1 2.97367C1 9.89158 6.60824 15.4998 13.5262 15.4998C14.34 15.4998 14.9996 14.84 14.9996 14.0261L15 11.8863C15 11.2503 14.6129 10.6784 14.0223 10.4422L11.9718 9.62226C11.4413 9.41007 10.8373 9.50556 10.3984 9.87133L9.86917 10.3127C9.25113 10.8277 8.34175 10.7868 7.77287 10.2179L6.2827 8.72637C5.71382 8.15749 5.67178 7.24885 6.18682 6.6308L6.62811 6.10163C6.99388 5.66271 7.09022 5.05855 6.87803 4.52806L6.05734 2.47799Z" stroke="#2E3D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </i>
          <div class="menu-item-name">Contacts</div>
        </div>

        <!-- Reviews -->
        <div
          ngbAccordionItem="reviews"
          [disabled]="!selectedLocation || isAccordionActive('reviews')"
          [collapsed]="!selectedLocation || !isAccordionActive('reviews')"
        >
          <div ngbAccordionHeader>
            <div ngbAccordionToggle class="menu-item menu-item-expandable"
              [class.menu-item-selected]="isAccordionActive('reviews')"
              (click)="(!selectedLocation && navigateTo('/admin-business/locations', { next: 'reviews' })) || closeInactiveOthers('reviews')"
            >
              <i class="icons">
                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.90909 12.8636H3.18182C2.65364 12.8636 2.20182 12.5455 2.01091 12.0873L0.0890909 7.6009C0.0318182 7.45454 0 7.30181 0 7.13636V5.86363C0 5.16363 0.572727 4.59091 1.27273 4.59091H5.28818L4.68364 1.68272L4.66455 1.47909C4.66455 1.21818 4.77273 0.976358 4.94455 0.804541L5.61909 0.13636L9.81273 4.33C10.0418 4.55909 10.1818 4.87727 10.1818 5.22727V11.5909C10.1818 12.2909 9.60909 12.8636 8.90909 12.8636ZM8.90909 5.22727L6.14727 2.46545L7 5.86363H1.27273V7.13636L3.18182 11.5909H8.90909V5.22727ZM11.4545 12.8636H14V5.22727H11.4545V12.8636Z" fill="#2E3D4F"/>
                </svg>
              </i>
              <div class="menu-item-name">Reviews</div>
              <i
                *ngIf="(reviewTargetWithError$ | async)" 
                ngbTooltip='Action Required'>
                <svg 
                  class="icon-info"
                  style="margin-left: 15px"
                  width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="6.5" cy="6.5" r="6.5" fill="red"/>
                  <path d="M6.55452 3.93867C6.26467 3.93867 6.04896 3.87801 5.90741 3.75667C5.76585 3.6286 5.69507 3.44323 5.69507 3.20056C5.69507 2.95115 5.76585 2.76578 5.90741 2.64445C6.04896 2.51638 6.26467 2.45234 6.55452 2.45234C6.84437 2.45234 7.06007 2.51638 7.20163 2.64445C7.34319 2.76578 7.41396 2.95115 7.41396 3.20056C7.41396 3.44323 7.34319 3.6286 7.20163 3.75667C7.06007 3.87801 6.84437 3.93867 6.55452 3.93867ZM7.24207 4.66667V9.72223H5.85685V4.66667H7.24207Z" fill="white"/>
                </svg>
              </i>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="submenu">
                  <div id="nav-location-reviews" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/reviews', true)"
                    (click)="navigateTo('/admin-location/reviews')">
                    My Reviews
                  </div>

                  <div id="nav-location-reviewSites" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/location-review-targets', true)"
                    (click)="navigateTo('/admin-location/location-review-targets')">
                    Review Sites
                    <!-- <i *ngIf="(reviewTargetWithError$ | async)| isFacebookEnabled | isGmbEnabled" class="fas fa-exclamation-circle nav-warn" ngbTooltip='Action Required'></i> -->
                      <i
                      *ngIf="(reviewTargetWithError$ | async)| isFacebookEnabled | isGmbEnabled"
                        ngbTooltip='Action Required'>
                        <svg 
                          class="icon-info"
                          style="margin-left: 15px"
                          width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="6.5" cy="6.5" r="6.5" fill="red"/>
                          <path d="M6.55452 3.93867C6.26467 3.93867 6.04896 3.87801 5.90741 3.75667C5.76585 3.6286 5.69507 3.44323 5.69507 3.20056C5.69507 2.95115 5.76585 2.76578 5.90741 2.64445C6.04896 2.51638 6.26467 2.45234 6.55452 2.45234C6.84437 2.45234 7.06007 2.51638 7.20163 2.64445C7.34319 2.76578 7.41396 2.95115 7.41396 3.20056C7.41396 3.44323 7.34319 3.6286 7.20163 3.75667C7.06007 3.87801 6.84437 3.93867 6.55452 3.93867ZM7.24207 4.66667V9.72223H5.85685V4.66667H7.24207Z" fill="white"/>
                        </svg>
                      </i>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- Review Requests -->
        <div
          ngbAccordionItem="review-requests"
          [disabled]="!selectedLocation || isAccordionActive('review-requests')"
          [collapsed]="!selectedLocation || !isAccordionActive('review-requests')"
        >
          <div ngbAccordionHeader>
            <div ngbAccordionToggle class="menu-item menu-item-expandable"
              [class.menu-item-selected]="isAccordionActive('review-requests')"
              (click)="(!selectedLocation && navigateTo('/admin-business/locations', { next: 'send' })) || closeInactiveOthers('review-requests')">
              <i class="icons">
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.02192 13.3027L4.20722 12.3545L4.21594 12.3478C4.46305 12.1501 4.58774 12.0503 4.72686 11.9792C4.85168 11.9155 4.98477 11.869 5.12207 11.8409C5.27682 11.8091 5.43803 11.8091 5.76161 11.8091H12.5135C13.383 11.8091 13.8183 11.8091 14.1507 11.6397C14.4434 11.4906 14.6815 11.2524 14.8306 10.9597C15 10.6272 15 10.1925 15 9.323V3.4067C15 2.53721 15 2.10181 14.8306 1.76939C14.6815 1.47669 14.4429 1.23889 14.1502 1.08976C13.8174 0.920212 13.3825 0.920212 12.5113 0.920212H3.48904C2.61785 0.920212 2.18193 0.920212 1.84918 1.08976C1.55648 1.23889 1.31868 1.47669 1.16955 1.76939C1 2.10214 1 2.53806 1 3.40925V12.3311C1 13.16 1 13.5744 1.16991 13.7872C1.31768 13.9724 1.54167 14.0801 1.77854 14.0798C2.0509 14.0795 2.37467 13.8205 3.02192 13.3027Z" stroke="#2E3D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
              <div class="menu-item-name">Review Requests</div>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="submenu">
                  <div id="nav-location-campaigns" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/campaigns', true)"
                    (click)="navigateTo('/admin-location/campaigns')">
                    Campaigns
                  </div>

                  <div id="nav-location-send"  class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/send', true)"
                    (click)="navigateTo('/admin-location/send')">
                    Send
                  </div>

                  <div id="nav-location-messages" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/feedback', true)"
                    (click)="navigateTo('/admin-location/feedback')">
                    Messages
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- Showcasing -->
        <div
          ngbAccordionItem="showcasing"
          [disabled]="!selectedLocation || isAccordionActive('showcasing')"
          [collapsed]="!selectedLocation || !isAccordionActive('showcasing')"
        >
          <div ngbAccordionHeader>
            <div ngbAccordionToggle class="menu-item menu-item-expandable"
              [class.menu-item-selected]="isAccordionActive('showcasing')"
              (click)="(!selectedLocation && navigateTo('/admin-business/locations', { next: 'widgets' })) || closeInactiveOthers('showcasing')"
            >
              <i class="icons">
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.4546 5.59091L12.2501 3.84091L14.0001 3.04545L12.2501 2.25L11.4546 0.5L10.6592 2.25L8.90918 3.04545L10.6592 3.84091L11.4546 5.59091Z" fill="#2E3D4F"/>
                  <path d="M11.4546 9.40909L10.6592 11.1591L8.90918 11.9545L10.6592 12.75L11.4546 14.5L12.2501 12.75L14.0001 11.9545L12.2501 11.1591L11.4546 9.40909Z" fill="#2E3D4F"/>
                  <path d="M6.68182 5.90909L5.09091 2.40909L3.5 5.90909L0 7.5L3.5 9.09091L5.09091 12.5909L6.68182 9.09091L10.1818 7.5L6.68182 5.90909ZM5.72091 8.13L5.09091 9.51727L4.46091 8.13L3.07364 7.5L4.46091 6.87L5.09091 5.48272L5.72091 6.87L7.10818 7.5L5.72091 8.13Z" fill="#2E3D4F"/>
                </svg>
              </i>
              <div class="menu-item-name">Showcasing</div>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="submenu">
                  <div id="nav-location-widgets" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/widgets', true)"
                    (click)="navigateTo('/admin-location/widgets')">
                    Widgets
                  </div>
                  <div id="nav-location-socialMedia" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/sharing', true)"
                    (click)="navigateTo('/admin-location/sharing')">
                    Social Sharing
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- Configurations -->
        <div
          *ngxPermissionsOnly="['viewBusinessAdminsMenu']"
          ngbAccordionItem="configurations"
          [disabled]="isAccordionActive('configurations')"
          [collapsed]="!isAccordionActive('configurations')"
        >
          <div ngbAccordionHeader>
            <div ngbAccordionToggle class="menu-item menu-item-expandable"
              (click)="closeInactiveOthers('configurations')"
              [class.menu-item-selected]="isAccordionActive('configurations')">
              <i class="icons">
                <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.88616 17.3603L14.6149 14.6302C15.1197 14.3387 15.3716 14.193 15.5552 13.9891C15.7176 13.8087 15.8404 13.5962 15.9154 13.3654C16 13.1051 16 12.8142 16 12.2341V6.76577C16 6.18561 16 5.89476 15.9154 5.63447C15.8404 5.40362 15.7176 5.19097 15.5552 5.01059C15.3724 4.8076 15.1211 4.66249 14.6206 4.37356L9.88532 1.63963C9.38052 1.34818 9.12862 1.20275 8.86028 1.14571C8.62286 1.09525 8.37739 1.09525 8.13997 1.14571C7.87163 1.20275 7.61889 1.34818 7.11409 1.63963L2.38443 4.37029C1.88022 4.6614 1.62832 4.80684 1.44486 5.01059C1.28244 5.19097 1.15978 5.40362 1.08477 5.63447C1 5.89537 1 6.18698 1 6.76987V12.2302C1 12.8131 1 13.1045 1.08477 13.3654C1.15978 13.5962 1.28244 13.8087 1.44486 13.9891C1.62842 14.193 1.88052 14.3387 2.38532 14.6302L7.11409 17.3603C7.61888 17.6518 7.87163 17.7973 8.13997 17.8543C8.37739 17.9048 8.62286 17.9048 8.86028 17.8543C9.12862 17.7973 9.38137 17.6518 9.88616 17.3603Z" stroke="#2E3D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.90189 9.49991C5.90189 10.9348 7.06511 12.098 8.5 12.098C9.93489 12.098 11.0981 10.9348 11.0981 9.49991C11.0981 8.06502 9.93489 6.9018 8.5 6.9018C7.06511 6.9018 5.90189 8.06502 5.90189 9.49991Z" stroke="#2E3D4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </i>
              <div class="menu-item-name">Configurations</div>
            </div>
          </div>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div class="submenu">
                  <div *ngIf="false" class="submenu-item"
                    id="nav-business-my"
                    [class.submenu-item-selected]="router.isActive('/admin-business/profile', true)"
                    (click)="navigateTo('/admin-business/profile')">
                    My Business
                  </div>
                  <div class="submenu-item"
                    id="nav-business-my"
                    [class.submenu-item-selected]="router.isActive('/admin-business/locations', true)"
                    (click)="navigateTo('/admin-business/locations')">
                    My Business/Locations
                  </div>
                  <div id="nav-business-users" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-business/users', true)"
                    (click)="navigateTo('/admin-business/users')">
                    Users
                  </div>
                  <div id="nav-business-users" class="submenu-item"
                    [class.submenu-item-selected]="router.isActive('/admin-location/employees', true)"
                    (click)="navigateTo('/admin-location/employees')">
                    Employee
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </perfect-scrollbar>

    <!-- blurred out side bar -->
    <div
      *ngIf="!(selectedBusiness$ | async)?.id"
      class="no-business position-relative h-100 w-100"
    ></div>
  </div>

  <ng-container *ngIf="(loggedUser$ | async).role.name == Role.SiteAdmin">
    <ng-container *ngxPermissionsOnly="['viewSiteAdminsMenu']">
      <div>
        <div class="d-flex flex-column text-center">
          <div class="bg">
            <div class="w-100 text-center py-2">
              <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><title>globe</title><g id="globe"><path d="M53.85,47.85A27,27,0,0,1,24,57.8V56l3-3V49l4-4V42l4,4h5l2-2h8Z"/><path d="M42,20.59v2.56L38.07,27H31l-5.36,5.26L31,37.51v5.06L27.44,39H22.86L16,32.11V24.2L11.8,20h-4A27,27,0,0,1,32,5a26.55,26.55,0,0,1,7.06.94L36,9H30v4l4,4h4.33Z"/><path d="M32,60A28,28,0,1,1,60,32,28,28,0,0,1,32,60ZM32,6A26,26,0,1,0,58,32,26,26,0,0,0,32,6Z"/></g></svg>

              Selected Reseller 
            </div>
          </div>
          <div class="py-2">
            {{ selectedResellerProfile ? selectedResellerProfile.name : "" }}
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
